import {
  FETCH_SETTINGS,
  FETCH_SETTINGS_SUCCESS,
  FETCH_SETTINGS_FAILED,
  EDIT_SETTINGS,
  CLEAR_SETTINGS_ERROR
} from "../store/types";

import { firebase } from '../config/configureFirebase';
import { onValue, update } from "firebase/database";

/** Punto de partida del "Acumulado" del dashboard admin; las reservas anteriores no se suman. */
export const resetDashboardEarnings = () => {
  const { settingsRef } = firebase;
  return update(settingsRef, { dashboardEarningsSince: Date.now() });
};

export const fetchSettings= () => (dispatch) => {

  const {
    settingsRef
  } = firebase;

  dispatch({
    type: FETCH_SETTINGS,
    payload: null,
  });
  onValue(settingsRef, (snapshot) => {
    if (snapshot.val()) {
      dispatch({
        type: FETCH_SETTINGS_SUCCESS,
        payload: snapshot.val(),
      });
    } else {
      dispatch({
        type: FETCH_SETTINGS_FAILED,
        payload: "Unable to fetch database and settings.",
      });
    }
  });
};

/**
 * Escribe solo los campos recibidos (update, no set): el resto de `settings`
 * (p. ej. dashboardEarningsSince, masterReferrerUid, blockIps) no se pisa con copias viejas.
 */
export const editSettings = (changes) => (dispatch) => {
  const {
    settingsRef
  } = firebase;
  dispatch({
    type: EDIT_SETTINGS,
    payload: changes
  });
  const clean = {};
  Object.keys(changes || {}).forEach((key) => {
    clean[key] = changes[key] === undefined ? null : changes[key];
  });
  if (!Object.keys(clean).length) return Promise.resolve();
  return update(settingsRef, clean);
};

export const clearSettingsViewError = () => (dispatch) => {
  dispatch({
    type: CLEAR_SETTINGS_ERROR,
    payload: null
  });
};